import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threetwoseaterbusrentalpune() {



const cardData =
  {
    keyword: '32 Seater Bus Rental Pune',
    heading: 'Sanavi Travels: 32 Seater Bus Rental Pune',
    headingDescription: 'Sanavi Travels offers reliable, spacious, and affordable 32 Seater Bus Rental Pune for medium to large group transportation needs across the city and beyond. Pune is a major hub for corporate offices, educational institutions, weddings, tourism, and industrial activities, creating constant demand for organized group travel. A 32 seater bus is one of the most preferred options as it offers the perfect balance between capacity, comfort, and cost-efficiency. Sanavi Travels provides well-maintained AC and Non-AC 32 seater buses with clean interiors, comfortable cushioned seating, adequate legroom, smooth suspension, and sufficient luggage space, ensuring a relaxed journey even for long distances. Whether it is a wedding function, corporate event, school trip, picnic, religious tour, or outstation journey, our 32 seater buses help groups travel together safely and on time.',

    top: 'Best Uses and Travel Routes for 32 Seater Bus Rental in Pune',


"topPlaces": [
  {
    "title": "City Travel Across Pune",
    "description": "A 32 seater bus is ideal for group travel across Pune’s busy city areas such as Shivajinagar, Kothrud, Hadapsar, Baner, Wakad, Hinjewadi, Viman Nagar, Kharadi, and Pimpri-Chinchwad. Corporate teams, students, and social groups frequently use 32 seater buses to move together efficiently without the hassle of coordinating multiple vehicles, especially during peak traffic hours."
  },
  {
    "title": "Corporate and IT Parks",
    "description": "Large corporate teams visiting IT parks and business hubs prefer 32 seater buses for conferences, training programs, team outings, and client visits. These buses provide a professional travel environment while ensuring everyone arrives together and on schedule."
  },
  {
    "title": "Wedding and Social Events",
    "description": "For weddings and large social functions, 32 seater buses are commonly used to transport guests, relatives, and community members between homes, hotels, temples, and venues. They help manage guest movement smoothly and reduce parking and traffic challenges."
  },
  {
    "title": "School and College Trips",
    "description": "Educational institutions regularly hire 32 seater buses for excursions, competitions, industrial visits, and educational tours. The seating capacity makes it suitable for transporting students and teachers together in a safe and organized manner."
  },
  {
    "title": "Picnic and Leisure Travel",
    "description": "Schools, offices, and families often plan picnic trips and leisure outings around Pune. A 32 seater bus offers comfortable seating, cost efficiency, and controlled travel for group picnics and recreational tours."
  },
  {
    "title": "Outstation Routes from Pune",
    "description": "Popular outstation destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Satara, Kolhapur, and Goa are frequently covered using 32 seater buses. These buses provide comfort and reliability for long-distance group travel."
  },
  {
    "title": "Religious and Spiritual Tours",
    "description": "Devotees traveling to temples and spiritual destinations prefer 32 seater buses for their capacity, comfort, and ease of coordination, especially for full-day or multi-day religious tours."
  },
  {
    "title": "Industrial and MIDC Areas",
    "description": "Industrial zones around Pune generate regular demand for staff movement, inspections, and official visits. A 32 seater bus is ideal for transporting employees and officials efficiently."
  },
  {
    "title": "Airport and Railway Station Transfers",
    "description": "For large group airport and railway transfers, 32 seater buses ensure all passengers and luggage are transported together comfortably and on time."
  },
  {
    "title": "Tourist Group Travel",
    "description": "Tour operators and travel groups often choose 32 seater buses for sightseeing tours, local travel, and multi-day trips due to their balanced capacity and comfort."
  }
]
,



"services": [
{
"name": "32 Seater Bus Rental Pune",
"description": "32 Seater Bus Rental Pune provides an ideal transportation solution for medium to large groups looking for comfort, safety, and affordability. These buses are well-maintained with clean interiors, cushioned seats, proper ventilation or air-conditioning, smooth suspension, and adequate luggage space, making them suitable for city travel as well as long-distance journeys. Sanavi Travels ensures professional drivers, punctual service, and flexible rental plans, making this service perfect for weddings, corporate travel, school trips, picnics, religious tours, and outstation journeys."
},
{
"name": "32 Seater Bus Hire Pune",
"description": "32 Seater Bus Hire Pune offers dependable and organized group transportation for events, office travel, and social functions. Hiring a single 32 seater bus helps reduce coordination issues, fuel expenses, and travel fatigue compared to multiple smaller vehicles."
},
{
"name": "AC 32 Seater Bus on Rent Pune",
"description": "AC 32 Seater Bus on Rent Pune ensures a cool and comfortable journey, especially during summer months and long travel routes. Air-conditioned buses are preferred for weddings, corporate events, school trips, and premium group travel."
},
{
"name": "Non AC 32 Seater Bus Hire Pune",
"description": "Non AC 32 Seater Bus Hire Pune is a cost-effective option suitable for short-distance travel, budget-conscious group trips, and local transportation needs without compromising safety."
},
{
"name": "Luxury 32 Seater Bus Rental Pune",
"description": "Luxury 32 Seater Bus Rental Pune offers enhanced interiors, superior seating comfort, and a refined travel experience ideal for VIP guests, corporate executives, and special occasions."
},
{
"name": "Mini 32 Seater Bus Hire Pune",
"description": "Mini 32 Seater Bus Hire Pune is suitable for groups that require a slightly compact bus while still enjoying sufficient seating capacity and comfort."
},
{
"name": "32 Seater Bus for Wedding Pune",
"description": "32 Seater Bus for Wedding Pune helps families manage guest transportation smoothly during weddings, receptions, and community functions, ensuring timely and organized travel."
},
{
"name": "32 Seater Bus for Corporate Travel Pune",
"description": "32 Seater Bus for Corporate Travel Pune supports conferences, meetings, training programs, and team outings with professional and punctual transportation."
},
{
"name": "32 Seater Bus for Picnic Pune",
"description": "32 Seater Bus for Picnic Pune offers safe, comfortable, and enjoyable group travel for schools, offices, and families planning leisure outings."
},
{
"name": "32 Seater Bus for Outstation Pune",
"description": "32 Seater Bus for Outstation Pune provides reliable long-distance transportation to popular tourist and religious destinations, ensuring comfort and group coordination."
},
{
"name": "Affordable 32 Seater Bus Hire Pune",
"description": "Affordable 32 Seater Bus Hire Pune delivers budget-friendly group travel solutions without compromising on vehicle condition, cleanliness, or service quality."
},
{
"name": "Best 32 Seater Bus Service Pune",
"description": "Best 32 Seater Bus Service Pune is trusted for clean buses, experienced drivers, transparent pricing, and dependable service from Sanavi Travels."
},
{
"name": "32 Seater Bus Hire with Driver Pune",
"description": "32 Seater Bus Hire with Driver Pune provides chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules professionally."
},
{
"name": "32 Seater Bus for Family Trip Pune",
"description": "32 Seater Bus for Family Trip Pune ensures comfortable and relaxed travel for large families planning tours, celebrations, or holidays together."
},
{
"name": "32 Seater Bus for Group Tour Pune",
"description": "32 Seater Bus for Group Tour Pune is ideal for friends, tourists, and organized travel groups seeking convenient and enjoyable transportation."
}
],
"tableData": [
["32 Seater Bus Rental Pune", "32 Seater Bus Hire Pune"],
["AC 32 Seater Bus Pune", "Non AC 32 Seater Bus Pune"],
["Luxury 32 Seater Bus Pune", "Mini 32 Seater Bus Pune"],
["32 Seater Wedding Bus Pune", "32 Seater Corporate Bus Pune"],
["32 Seater Picnic Bus Pune", "32 Seater Family Bus Pune"],
["32 Seater Outstation Bus Pune", "32 Seater Bus with Driver Pune"],
["Affordable 32 Seater Bus Pune", "Best 32 Seater Bus Service Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "32 Seater Bus Rental Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable 32 seater bus services across Pune."
  },
  {
    "WhyChooseheading": "Ideal Capacity for Group Travel",
    "WhyChoosedescription": "Perfect balance between seating capacity, comfort, and cost-efficiency."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Drivers are trained for city, highway, and long-distance travel."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Fleet",
    "WhyChoosedescription": "Buses are regularly serviced and cleaned for passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Hourly, daily, event-based, and outstation rental options available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Travel",
    "WhyChoosedescription": "All buses are sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "On-time pickups and smooth journey execution."
  }
]

}

const faqData = [
  {
    question: 'Do you provide 32 seater bus rental in Pune?',
    answer: 'Yes, Sanavi Travels offers 32 seater bus rental services across Pune.'
  },
  {
    question: 'Are AC and Non AC 32 seater buses available?',
    answer: 'Yes, both AC and Non AC 32 seater buses are available.'
  },
  {
    question: 'Can I hire a 32 seater bus for outstation travel?',
    answer: 'Yes, 32 seater buses are available for long-distance and outstation journeys.'
  },
  {
    question: 'Is a driver included with the bus?',
    answer: 'Yes, all 32 seater bus rentals include experienced professional drivers.'
  },
  {
    question: 'Are the buses cleaned and sanitized?',
    answer: 'Yes, buses are cleaned and sanitized before every trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'We hired a 32 seater bus in Pune for a wedding event. Very comfortable and well-managed service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rina Joshi',
    feedback: 'Excellent 32 seater bus service for our corporate outing. Smooth and reliable.',
    rating: 5
  }
];

























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus Rental Pune - Sanavi Travels",
  "description": "Sanavi Travels offers 32 seater bus rental in Pune for weddings, corporate travel, picnics, outstation trips, family trips, and group tours. We provide AC and Non-AC 32 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | 32 Seater Bus Rental Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 32 seater bus rental in Pune with Sanavi Travels. AC & Non-AC buses for weddings, corporate travel, picnics, outstation trips, family trips, and group tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/244.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threetwoseaterbusrentalpune;